export enum DeliveryType {
  CIF = "CIF",
  FOB = "FOB",
}
